// reCAPTCHA v3/v2 invisible wrapper (client-side only)
// Note: Pour la démo, on garde l'intégration optionnelle. Renseignez la clé site via env si besoin.

declare global {
  interface Window {
    grecaptcha?: any;
  }
}

let scriptInjected = false;

export function injectRecaptcha(siteKey?: string) {
  if (!siteKey || scriptInjected) return;
  const s = document.createElement('script');
  s.async = true;
  s.defer = true;
  s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
  document.head.appendChild(s);
  scriptInjected = true;
}

export async function executeRecaptcha(action: string, siteKey?: string): Promise<string | null> {
  try {
    if (!siteKey) return null;
    injectRecaptcha(siteKey);
    if (!window.grecaptcha) {
      await new Promise(resolve => setTimeout(resolve, 300));
    }
    if (!window.grecaptcha) return null;
    await window.grecaptcha.ready?.();
    const token = await window.grecaptcha.execute(siteKey, { action });
    return token as string;
  } catch {
    return null;
  }
}




